/**
 * @author: liaojianming
 * @date 2019-02-21
 * @description: 系统管理-菜单模块
*/

import request from '@/plugin/axios';

const apiUrl = process.env.VUE_APP_API;

// 查询所有的菜单类型列表
export function QuerySystemMenuTypePageList(data) {
    return request({
        url: apiUrl + 'system_menu_permission/list_menu_type',
        method: 'POST',
        data
    });
}

// 查询菜单树形结构
export function QuerySystemMenuNodeList(data) {
    return request({
        url: apiUrl + 'system_menu_permission/tree_menu',
        method: 'POST',
        data
    });
}

// 新增菜单节点
export function AddSystemMenuNode(data) {
    return request({
        url: apiUrl + 'system_menu_permission/add_menu_permission_node',
        method: 'POST',
        data
    });
}

// 查询菜单详情
export function QuerySystemMenuInfo(data) {
    return request({
        url: apiUrl + 'system_menu_permission/detail_by_id',
        method: 'POST',
        data
    });
}

// 删除菜单权限数据
export function DeleteSystemMenuNode(data) {
    return request({
        url: apiUrl + 'system_menu_permission/delete_menu_permission_node',
        method: 'POST',
        data
    });
}

// 查询菜单分页信息
export function QuerySystemMenuPageList(data) {
    return request({
        url: apiUrl + 'system_menu_permission/page_by_query',
        method: 'POST',
        data
    });
}

// 查询服务配置列表信息
export function QuerySystemServerConfigList(data) {
    return request({
        url: apiUrl + 'server_config/list_by_query',
        method: 'POST',
        data
    });
}

// 更新菜单节点
export function UpdateSystemMenuNode(data) {
    return request({
        url: apiUrl + 'system_menu_permission/update_for_ordinary',
        method: 'POST',
        data
    });
}

//获取菜单属性列表
export function getMenuProptyData(data) {
    return request({
        url: apiUrl + 'system_menu_data_permission/page_by_query',
        method: 'POST',
        data
    });
}

//保存菜单数据权限
export function saveMenuProptyData(data) {
    return request({
        url: apiUrl + 'system_menu_data_permission/save_for_ordinary',
        method: 'POST',
        data
    });
}

//菜单数据详情
export function getMenuProptyDetail(data) {
    return request({
        url: apiUrl + 'system_menu_data_permission/detail_by_id',
        method: 'POST',
        data
    });
}
//删除菜单数据
export function deleteMenuPropty(data) {
    return request({
        url: apiUrl + 'system_menu_data_permission/delete_by_id',
        method: 'POST',
        data
    });
}
//更新菜单节点
export function updateMenuPropty(data) {
    return request({
        url: apiUrl + 'system_menu_permission/update_for_ordinary',
        method: 'POST',
        data
    });
}


